import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';

import { DialogConstant } from '../../Constant';

import { ApiService } from '../../service/api.service';
import { DialogService } from '../../service/dialog.service';
import { EventService } from '../../service/event.service';

@Component({
    selector: 'app-setting-modal',
    templateUrl: './setting-modal.page.html',
    styleUrls: ['./setting-modal.page.scss'],
})
export class SettingModalPage
{
    constructor(
        private nav: NavController,
        private api: ApiService,
        private dialog: DialogService,
        private event: EventService
    )
    {
    }

    ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'setting-modal', value: null});
    }

    async moveSetting()
    {
        await this.settingClose();
        this.nav.navigateRoot(`/profile`);
    }

    async logout()
    {
        await this.settingClose();

        const btn1 = {
            text: DialogConstant.BUTTON_CANCEL,
            role: 'cancel'
        };

        const btn2 = {
            text: DialogConstant.BUTTON_OK,
            handler: async() => {
                await this.api.logout();
            }
        };

        this.dialog.confirm(DialogConstant.CONFIRM_TITLE, DialogConstant.LOGOUT_CONFIRM, [btn1, btn2]);
    }

    async settingClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'setting-modal', value: null});
        await new Promise(resolve => setTimeout(resolve, 300));
    }
}
